import { catalogDataColumns, categoryGroupsFor, gridLayout } from "./catalogColumns";

const CLIENT_IDENTITY_COLUMNS = [
    {
        key: "clientName",
        label: "Client",
        category: "General",
        frozen: true,
        width: 200,
        value: (client) => client.displayName ?? null,
    },
    {
        key: "plans",
        label: "Plans",
        category: "General",
        frozen: true,
        width: 120,
        value: (client) => client.plansCount ?? null,
    },
];

const clientGridLayout = (fields, extraFrozen = []) => {
    const columns = [...CLIENT_IDENTITY_COLUMNS, ...catalogDataColumns(fields)];
    return {
        columns,
        ...gridLayout([...CLIENT_IDENTITY_COLUMNS, ...extraFrozen], categoryGroupsFor(columns)),
    };
};

export { CLIENT_IDENTITY_COLUMNS, clientGridLayout };
